import { useQuery } from "@tanstack/react-query"

import { getData } from "../services/inmunoterapia.service";

export const usePacienteInmunoterapiaData = (id) => {

    const pacienteInmunoterapiaDataQuery = useQuery({
        queryKey: ['paciente/inmunoterapia/data', id],
        queryFn: () => getData(id),
        staleTime: 0, // nulo
    });

    return {
        pacienteInmunoterapiaDataQuery,
    }
}